export default function () {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 70 56" fill="none">
            <path
                d="M0 -0.494141H70V40.8779C70 42.5964 68.9023 44.1229 67.2732 44.6699L36.2732 55.0784C35.4471 55.3558 34.5529 55.3558 33.7268 55.0784L2.72682 44.6699C1.09768 44.1229 0 42.5964 0 40.8779V-0.494141Z"
                fill="#FF8000"
            />
            <path
                d="M0 -0.494141H70V40.8779C70 42.5964 68.9023 44.1229 67.2732 44.6699L36.2732 55.0784C35.4471 55.3558 34.5529 55.3558 33.7268 55.0784L2.72682 44.6699C1.09768 44.1229 0 42.5964 0 40.8779V-0.494141Z"
                fill="url(#paint0_linear_280_2727)"
            />
            <defs>
                <linearGradient id="paint0_linear_280_2727" x1="70" y1="35.9059" x2="-35.5094" y2="62.1681" gradientUnits="userSpaceOnUse">
                    <stop offset="0.0161916" stopColor="#FD720E" />
                    <stop offset="0.364526" stopColor="#FF910F" />
                    <stop offset="0.6434" stopColor="#FFB84F" />
                </linearGradient>
            </defs>
        </svg>
    );
}
